import * as React from "react";
import { forwardRef } from "react";
const Svg24Px = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { x: 3.54199, y: 4.04169, width: 12.9167, height: 12.9167, rx: 1.5, stroke: "currentColor", strokeWidth: 1.25 }), /* @__PURE__ */ React.createElement("path", { d: "M7.29199 5.5V7.5M7.29199 9.5V11.5M7.29199 13.5V15.5M12.708 5.5V7.5M12.708 9.5V11.5M12.708 13.5V15.5", stroke: "currentColor", strokeWidth: 1.25 }));
const ForwardRef = forwardRef(Svg24Px);
export default ForwardRef;
